(async () => {
    const carSearch = document.querySelector('[data-car-search]');

    if (carSearch) {
        await import('/components/car-search/car-search-lazy');
    }
})();
